// External libraries
import { ApolloLink } from 'apollo-link';

// Internal modules
import { authLink } from './authLink';
import { loggerLink } from './loggerLink';
import { httpLink } from './httpLink';
import { retryLink } from './retryLink';

export const getLinks = (): ApolloLink => {
  return ApolloLink.from([
    loggerLink,
    authLink,
    retryLink,
    httpLink, // Terminating link
  ]);
};
